import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POILiftStateFields from "@/components/POI/POIStateFields/POILiftStateFields/POILiftStateFields.vue";

export default {
  components: { POIStep, POILiftStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
